export const CLIRNET_API = {
  // Per environment from .env.uat / .env.prod (API_BASE_URL); the QA host when unset.
  BASE_URL: (import.meta.env.API_BASE_URL || "https://beqa.clirdev.com/api").replace(/\/+$/, ""),
  POLL_SUBMIT: "survey/poll-answer",
  POLL_ANSWER_SHOW: "/survey/poll-result?id=",
  INRACTIVE_QUIZ_SUBMIT: "interactive-quiz/submit",
  LIKE_SUBMIT: "content/like",
  USER_DETAILS: "user/detail/moderator",
  // Keyed by the interactive quiz's poll id, not the session id.
  QUIZ_result: (pollId) =>
    pollId != null && String(pollId).length
      ? `cme/poll/result/${encodeURIComponent(String(pollId))}`
      : `cme/poll/result/100`,
  SESSSION_DETAILS: (sessionId) => `/cme/detail/${encodeURIComponent(String(sessionId ?? ""))}`,
  CME_COMMENT_UPDATE: "cme/comment/update",
  // Logs an admin chat message in the DB (see addAdminChatComment).
  CME_COMMENT_ADD: "cme/comment/add",
  // Records a chat message's pin state in the DB (see setCmeCommentPinned).
  CME_COMMENT_PINNED: "cme/comment/pinned",
  HOST_VENDOR: (vendor, meetingNumber) =>
    `/cme/hostvendor/${encodeURIComponent(String(vendor ?? ""))}/${encodeURIComponent(String(meetingNumber ?? ""))}`,
  STREAM_PUBLISH: (vendorType) => {
    const key = String(vendorType ?? "").trim().toLowerCase() || "zoom";
    return `/cme/streampublish/${encodeURIComponent(key)}`;
  },
  // Streaming vendors available for the session's hosting vendor:
  // cme/vendor/list/{realtimekit|zoom|100ms}
  VENDOR_LIST: (hostingVendor) => `cme/vendor/list/${encodeURIComponent(String(hostingVendor ?? ""))}`,
  // Creative videos the admin can push live on stratcreative: cme/streaming-creative/{tenant},
  // tenant = the session's cme-common data.detail.tenet (e.g. "clirnet").
  STREAMING_CREATIVE: (tenant) => `cme/streaming-creative/${encodeURIComponent(String(tenant ?? ""))}`,
  AUTH_REFRESH: "refresh",
  ABLY_LOGIN: "ably/login",
};
